import StoreGetter from "@/constants/StoreGetter";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import interviewStartForm from "./S090300-InterviewStart/S090300-InterviewStart.vue";
import Settings from "../../../constants/Settings";
export default {
  name: "CandidateJobInterviewStart",
  components: {
    interviewStartForm
  },
  mounted() {
    this.checkCandidateData();
  },
  data: () => ({
    jobInterviewStartLocalization: t,
    menuId: Settings.MenuID.JobApplicationForm,
    Settings: Settings,
    jobInterviewStartDictEnum: dictEnum,
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    candidateInvited() {
      return this.$store.getters[StoreGetter.candidateInvited];
    }
  },
  methods: {
    checkCandidateData() {
      var self = this;
      if (self.candidateInvited == undefined || self.candidateInvited.CandID == undefined || self.candidateInvited.CandID == "") {
        self.$router.push(`/JobApplicationForm`);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobInterviewStart/S090300-CandidateJobInterviewStart.js